import { render, staticRenderFns } from "./textMessage.vue?vue&type=template&id=c70c648e&scoped=true&"
import script from "./textMessage.vue?vue&type=script&lang=js&"
export * from "./textMessage.vue?vue&type=script&lang=js&"
import style0 from "./textMessage.vue?vue&type=style&index=0&id=c70c648e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70c648e",
  null
  
)

export default component.exports